// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3YwW5","buttons":"Footer_buttons__ZWNcC"};